import { render, staticRenderFns } from "./categoriaproducto.vue?vue&type=template&id=3705d367&"
import script from "./categoriaproducto.vue?vue&type=script&lang=js&"
export * from "./categoriaproducto.vue?vue&type=script&lang=js&"
import style0 from "./categoriaproducto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports